import myOrder from './myOrder'
import ticketWallet from './ticketWallet'

let api = {
  ...myOrder,
  ...ticketWallet
}
const apiFiles = require.context('./', true, /api_.*\.js/)
apiFiles.keys().reduce((modules, modulePath) => {
  const moduleName = modulePath.replace(/^\.\/(.*)\.\w+$/, '$1')
  const value = apiFiles(modulePath)
  api = Object.assign(api, value)
}, {})
// var api = Object.assign({}, userLogin)
// api = Object.assign(api, test)
module.exports = api
